export default function StepperInprogressIco({ size }) {
  return (
    <svg
      width={size || "32"}
      height={size || "32"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill={"#7F56D9"} />
      <circle cx="16" cy="16" r="7" fill="white" />
    </svg>
  );
}
